// import './UserList.css';
import { Box, Button, Grid2, MenuItem, Select, FormControl, Avatar } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import useMediaQuery from "@mui/material/useMediaQuery";
import Axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import toast, { Toaster } from 'react-hot-toast';
import consts from "../../constant";
import Header from "../Header/Header";
import { useForm, Controller } from "react-hook-form";
import "./Asset.css";

// import './Kyc.css'
const drawerWidth = 260;

const CreateAsset = () => {
    const theme = useTheme();
    const lg = useMediaQuery(theme.breakpoints.up("lg"));
    const detail = useLocation();
    const [reason, setReason] = useState();
    const [reasons, setReasons] = useState(false);
    const [networks, setNetworks] = useState([]);
    const Navigate = useNavigate();
    const back = useNavigate();
    const { register, handleSubmit, setValue, control, formState: { errors } } = useForm();
    const token = localStorage.getItem("adminToken")

    const getNetworks = async () => {
        try {
            const response = await Axios.get(`${consts.BackendUrl}/admin/networks`, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Headers": "Content-Type, Authorization",
                    "Access-Control-Allow-Credentials": "true",
                    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
                    Authorization: token,
                },
            });

            const { data: responseData } = response;
            if (responseData?.success) {
                setNetworks(responseData?.result);
            }
        } catch (error) {
            console.error(error, "Error creating pair");
        }
    };

    const onSubmit = async (data) => {
        console.log(data, "asset Dataaa");
        try {
            const response = await Axios.post(`${consts.BackendUrl}/addassets`, data, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Headers": "Content-Type, Authorization",
                    "Access-Control-Allow-Credentials": "true",
                    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
                    Authorization: token,
                },
            });

            const { data: responseData } = response;
            if (responseData?.success) {
                setTimeout(() => {
                    toast.success(responseData?.message || "Operation successful!");
                }, 1000);
                back(`/${consts.route}/asset`)
            } else {
                toast.error(responseData?.message || "An unexpected error occurred.");
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.message || error?.message || "Something went wrong!";
            toast.error(errorMessage);
            console.error(error, "Error creating pair");
        }
    };

    useEffect(() => {
        getNetworks();
    }, []);


    const handleImageUpload = async (event) => {
        const file = event.target.files[0];
        if (file) {
            try {
                const formData = new FormData();
                formData.append("image", file);

                const response = await Axios.post(`${consts.BackendUrl}/admin/imageUploadAdmin`, formData, {
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        "Access-Control-Allow-Headers": "Content-Type, Authorization",
                        "Access-Control-Allow-Credentials": "true",
                        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
                        Authorization: token,
                    },
                });

                if (response?.data?.success) {
                    const uploadedImageUrl = response?.data?.result;
                    setValue("image", uploadedImageUrl);
                }
            } catch (error) {
                console.error("Error uploading image:", error);
            }
        }
    };

    return (
        <div className="UserList create-asset">
            <Box sx={{ display: lg ? "flex" : "block" }}>
                <Header />
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        p: 5,
                        width: { lg: `calc(100% - ${drawerWidth}px)` },
                        marginTop: "50px",
                    }}
                >
                    <Grid2 container spacing={2}>
                        <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                            <div className="d-flex align-fe">
                                <Button
                                    className="Backbutton"
                                    variant="contained"
                                    onClick={() => {
                                        back(`/${consts.route}/asset`);
                                    }}
                                >
                                    Back
                                </Button>
                            </div>

                            <div
                                className="image-upload-section mt-20"
                                style={{ display: "flex", alignItems: "center", marginBottom: "20px" }}
                            >
                                <Controller
                                    name="image"
                                    control={control}
                                    rules={{ required: "Image is required" }}
                                    render={({ field }) => (
                                        <>
                                            <Avatar
                                                alt="Current Image"
                                                src={field?.value ? field?.value : undefined}
                                                sx={{ width: 80, height: 80, marginRight: "20px" }}
                                            />
                                            <Button variant="contained" component="label">
                                                Upload Image
                                                <input
                                                    type="file"
                                                    hidden
                                                    accept="image/*"
                                                    onChange={(e) => {
                                                        handleImageUpload(e);
                                                        field.onChange(e.target.files[0]);
                                                    }}
                                                />
                                            </Button>
                                        </>
                                    )}
                                />
                            </div>

                            {errors?.image && <p className="err">{errors?.image?.message}</p>}

                            <div className="custom_table p-10">
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <Grid2
                                        container
                                        spacing={0}
                                        style={{ height: "100%" }}
                                        alignItems={"center"}
                                    >
                                        <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}
                                            sx={{
                                                "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                                    color: "white",
                                                },

                                            }}
                                        >
                                            <div className="view-inp p-10">
                                                <div className=" txt-white ">Name</div>
                                                <div className="mt-10">
                                                    <TextField
                                                        type="text"
                                                        {...register("name", { required: "Name is required" })}
                                                        id="outlined-basic"
                                                        variant="outlined"
                                                        fullWidth
                                                    />
                                                </div>
                                                <p className="err">{errors?.name?.message}</p>
                                            </div>

                                            <div className="view-inp p-10">
                                                <div className=" txt-white ">Symbol</div>
                                                <div className="mt-10">
                                                    <TextField
                                                        type="text"
                                                        {...register("symbol", { required: "Symbol is  required" })}
                                                        id="outlined-basic"
                                                        variant="outlined"
                                                        fullWidth
                                                    />
                                                </div>
                                                <p className="err">{errors?.symbol?.message}</p>
                                            </div>

                                            <div className="view-inp p-10">
                                                <div className=" txt-white ">Day Limit</div>
                                                <div className="mt-10">
                                                    <TextField
                                                        type="number"
                                                        {...register("dayLimit", { required: "dayLimit percentage required" })}
                                                        id="outlined-basic"
                                                        variant="outlined"
                                                        fullWidth
                                                    />
                                                </div>
                                                <p className="err">{errors?.dayLimit?.message}</p>
                                            </div>

                                            <div className="view-inp p-10">
                                                <div className=" txt-white ">Network Id </div>
                                                <div className="mt-10">
                                                    <TextField
                                                        {...register("networkId", { required: "networkId is required" })}
                                                        id="outlined-basic"
                                                        variant="outlined"
                                                        fullWidth
                                                    />
                                                </div>
                                                <p className="err">{errors?.networkId?.message}</p>
                                            </div>


                                            <div className="view-inp p-10">
                                                <div className="txt-white">Coin Type </div>
                                                <div className="mt-10">
                                                    <Controller
                                                        name="coinType"
                                                        control={control}
                                                        defaultValue=""
                                                        rules={{
                                                            required: "coinType is required", // Validation rule for required field
                                                        }}
                                                        render={({ field }) => (
                                                            <FormControl fullWidth variant="outlined">
                                                                <Select
                                                                    sx={{
                                                                        "& .MuiSelect-icon": { color: "white" },
                                                                        "& .MuiSelect-select": { color: "white" },
                                                                    }}
                                                                    {...field}
                                                                    labelId="withdraw-type-label"
                                                                    label="Select Coin Type"
                                                                    defaultValue=""
                                                                >
                                                                    <MenuItem disabled>Select Coin Type</MenuItem>
                                                                    <MenuItem value="0">Coin</MenuItem>
                                                                    <MenuItem value="1">Token</MenuItem>
                                                                </Select>
                                                            </FormControl>
                                                        )}
                                                    />
                                                </div>
                                                {errors?.withdrawType && <p className="err">{errors?.withdrawType?.message}</p>} {/* Validation error message */}
                                            </div>

                                            <div className="view-inp p-10">
                                                <div className=" txt-white ">Min_Deposit </div>
                                                <div className="mt-10">
                                                    <TextField
                                                        {...register("min_deposit", { required: "min_deposit is required" })}
                                                        id="outlined-basic"
                                                        variant="outlined"
                                                        fullWidth
                                                    />
                                                </div>
                                                <p className="err">{errors?.min_deposit?.message}</p>
                                            </div>

                                            <div className="view-inp p-10">
                                                <div className=" txt-white ">Min_Withdraw </div>
                                                <div className="mt-10">
                                                    <TextField
                                                        {...register("min_withdraw", { required: "min_withdraw is required" })}
                                                        id="outlined-basic"
                                                        variant="outlined"
                                                        fullWidth
                                                    />
                                                </div>
                                                <p className="err">{errors?.min_withdraw?.message}</p>
                                            </div>



                                            {/* </div> */}
                                        </Grid2>
                                        <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}
                                            sx={{
                                                "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                                    color: "white",
                                                },

                                            }}
                                        >

                                            <div className="view-inp p-10">
                                                <div className=" txt-white ">Max_Withdraw </div>
                                                <div className="mt-10">
                                                    <TextField
                                                        {...register("max_withdraw", { required: "max_withdraw is required" })}
                                                        id="outlined-basic"
                                                        variant="outlined"
                                                        fullWidth
                                                    />
                                                </div>
                                                <p className="err">{errors?.max_withdraw?.message}</p>
                                            </div>


                                            <div className="view-inp p-10">
                                                <div className=" txt-white ">
                                                    withdraw_commission
                                                </div>
                                                <div className="mt-10">
                                                    <TextField
                                                        type="number"
                                                        {...register("withdraw_commission", { required: "Withdraw Comission required" })}
                                                        id="outlined-basic"
                                                        variant="outlined"
                                                        fullWidth
                                                    />
                                                </div>
                                                <p className="err">{errors?.withdraw_commission?.message}</p>
                                            </div>

                                            <div className="view-inp p-10">
                                                <div className=" txt-white ">Coin ID</div>
                                                <div className="mt-10">
                                                    <TextField
                                                        type="text"
                                                        {...register("coinId", { required: "coinId required" })}
                                                        id="outlined-basic"
                                                        variant="outlined"
                                                        fullWidth
                                                    />
                                                </div>
                                                <p className="err">{errors?.coinId?.message}</p>
                                            </div>



                                            <div className="view-inp p-10">
                                                <div className="txt-white">withdraw Type</div>
                                                <div className="mt-10">
                                                    <Controller
                                                        name="withdrawType"
                                                        control={control}
                                                        defaultValue=""
                                                        rules={{
                                                            required: "Withdraw type is required", // Validation rule for required field
                                                        }}
                                                        render={({ field }) => (
                                                            <FormControl fullWidth variant="outlined">
                                                                <Select
                                                                    sx={{
                                                                        "& .MuiSelect-icon": { color: "white" },
                                                                        "& .MuiSelect-select": { color: "white" },
                                                                    }}
                                                                    {...field}
                                                                    labelId="withdraw-type-label"
                                                                    label="Withdraw Type"
                                                                    defaultValue=""
                                                                >
                                                                    <MenuItem disabled>Select Withdraw Type</MenuItem>
                                                                    <MenuItem value="0">Manual</MenuItem>
                                                                    <MenuItem value="1">Automatic</MenuItem>
                                                                </Select>
                                                            </FormControl>
                                                        )}
                                                    />
                                                </div>
                                                {errors?.withdrawType && <p className="err">{errors?.withdrawType?.message}</p>} {/* Validation error message */}
                                            </div>

                                            <div className="view-inp p-10">
                                                <div className=" txt-white ">WalletId</div>
                                                <div className="mt-10">
                                                    <TextField
                                                        {...register("walletId", { required: " walletId required" })}
                                                        id="outlined-basic"
                                                        variant="outlined"
                                                        fullWidth
                                                    />
                                                </div>
                                                <p className="err">{errors?.walletId?.message}</p>
                                            </div>

                                            <div className="view-inp p-10">
                                                <div className=" txt-white ">Deposit_Wallet_Id</div>
                                                <div className="mt-10">
                                                    <TextField
                                                        type="number"
                                                        {...register("depositWalletId", { required: "depositWalletId is required" })}
                                                        id="outlined-basic"
                                                        variant="outlined"
                                                        fullWidth
                                                    />
                                                </div>
                                                <p className="err">{errors?.depositWalletId?.message}</p>
                                            </div>


                                            <div className="view-inp p-10">
                                                <div className="txt-white">Currency Type </div>
                                                <div className="mt-10">
                                                    <Controller
                                                        name="currencyType"
                                                        control={control}
                                                        defaultValue=""
                                                        rules={{
                                                            required: "currencyType is required", // Validation rule for required field
                                                        }}
                                                        render={({ field }) => (
                                                            <FormControl fullWidth variant="outlined">
                                                                <Select
                                                                    sx={{
                                                                        "& .MuiSelect-icon": { color: "white" },
                                                                        "& .MuiSelect-select": { color: "white" },
                                                                    }}
                                                                    {...field}
                                                                    labelId="currency Type-label"
                                                                    label="Select Coin Type"
                                                                    defaultValue=""
                                                                >
                                                                    <MenuItem disabled>Select Currency Type</MenuItem>
                                                                    <MenuItem value="0">Crypto</MenuItem>
                                                                    <MenuItem value="1">Fiat</MenuItem>
                                                                </Select>
                                                            </FormControl>
                                                        )}
                                                    />
                                                </div>
                                                {errors?.currencyType && <p className="err">{errors?.currencyType?.message}</p>} {/* Validation error message */}
                                            </div>

                                            {/* <div className="view-inp p-10">
                                                <div className="txt-white">Type</div>
                                                <div className="mt-10">
                                                    <Controller
                                                        name="type" // Name of the field
                                                        control={control}
                                                        defaultValue="" // Default value (optional)
                                                        rules={{
                                                            required: "Type is required", // Validation rule for required field
                                                        }}
                                                        render={({ field }) => (
                                                            <FormControl fullWidth variant="outlined" error={!!errors?.type}>
                                                                <Select
                                                                    sx={{
                                                                        "& .MuiSelect-icon": { color: "white" },
                                                                        "& .MuiSelect-select": { color: "white" },
                                                                    }}
                                                                    {...field}
                                                                    labelId="type-label"
                                                                    label="Type"
                                                                    defaultValue=""
                                                                >
                                                                    <MenuItem value="coin">Coin</MenuItem>
                                                                    <MenuItem value="token">Token</MenuItem>
                                                                </Select>
                                                            </FormControl>
                                                        )}
                                                    />
                                                </div>
                                                {errors?.type && <p className="err">{errors?.type?.message}</p>}
                                            </div>
                                            <div className="view-inp p-10">
                                                <div className=" txt-white ">Contract Address</div>
                                                <div className="mt-10">
                                                    <TextField
                                                        {...register("Contract_Address", { required: "Contract Address required" })}
                                                        id="outlined-basic"
                                                        variant="outlined"
                                                        fullWidth
                                                    />
                                                </div>
                                                <p className="err">{errors?.Contract_Address?.message}</p>
                                            </div> */}
                                        </Grid2>
                                    </Grid2>
                                    <Button type="submit" variant='contained' sx={{ margin: "20px 10px", padding: "8px 40px" }}>
                                        Save
                                    </Button>
                                </form>
                            </div>
                        </Grid2>
                    </Grid2>
                </Box>
            </Box>
            <Toaster />
        </div>
    );
};

export default CreateAsset;
